<template>
  <div class="goodsAcountDetail">
    <div class="content">
      <div class="back" @click="goBack">
        <md-icon name="arrow-left" size="xs" style="font-size: 0.24rem;"></md-icon>
        <span>返回</span>
      </div>
      <div class="tl">
        <div class="left">
          <span>{{detailQuery.name}}</span>
          <span>
            <span v-if="detailQuery.bale==1" style="background:#DAEFFB;color:#1D78C5">定装</span>
            <span v-if="detailQuery.bale==2" style="background:#FBEDDA;color:#BF8535">非定装</span>
            <span v-if="detailQuery.bale==3" style="background:#DAFBDB;color:#4B9C64">散装</span>
          </span>
          <span>
            商品金额共
            <span>{{detailQuery.goods_total_price*1}}</span>元，
          </span>
          <span>{{detailQuery.count}}单</span>
        </div>
        <div class="time">
          <Calendar v-model="data_picker" @change="changeTime"></Calendar>
        </div>
      </div>
      <div class="listBox" v-if="list.length>0">
        <div class="title">
          <span>序号</span>
          <span>结算时间</span>
          <span>货主</span>
          <span>
            数量
            <span v-if="goods_type!=2">|重量</span>
          </span>
          <span>均价</span>
          <span>商品金额</span>
          <span>买家</span>
          <span>收银员</span>
          <span></span>
        </div>
        <div class="detailBox">
          <md-scroll-view
            ref="scrollView"
            :auto-reflow="false"
            :bouncing="true"
            :scrolling-x="false"
            @end-reached="$_onEndReached"
          >
            <div
              v-for="(item,index) in list"
              :key="index"
              class="list"
              @click="lookDetail(item.order_sn)"
            >
              <span>{{index+1}}</span>
              <span>{{item.pay_time |toTime}}</span>
              <span>{{item.supplier_name}}</span>
              <span>
                <span v-if="goods_type==1">
                  <span v-if="item.bale!=3">{{item.num*1}}{{unit_list[item.num_unit-1].name}} |</span>
                  {{item.weight*1}}公斤
                </span>
                <span v-if="goods_type==2">{{item.num*1}}个</span>
              </span>
              <span>
                <span v-if="goods_type==1">
                  <span
                    v-if="item.bale!=3"
                  >{{item.price_unit*1}}元/{{unit_list[item.num_unit-1].name}}</span>
                  <span v-else>{{item.price_weight*1}}元/公斤</span>
                </span>
                <span v-if="goods_type==2">
                  <span>{{item.price_unit*1}}元</span>
                  <span v-if="item.type==1">/个</span>
                  <span v-if="item.type==2">/单</span>
                </span>
              </span>
              <span>{{item.goods_total_price*1}}元</span>
              <span>{{item.buyer_name}}</span>
              <span>{{item.casher}}</span>
              <span>
                <md-icon name="arrow-right" size="sm"></md-icon>
              </span>
            </div>
            <md-scroll-view-more
              :finished-text="list.length>0?'全部已加载':'暂无数据'"
              slot="more"
              :is-finished="isFinished"
            ></md-scroll-view-more>
          </md-scroll-view>
        </div>
      </div>
      <div v-if="list.length==0" style="text-align:center;color:#999">暂无数据~</div>
    </div>
    <!-- 详情 -->
    <orderDetail
      :pop_show="isPopupShow"
      :orderId="orderId"
      @cancel="isPopupShow=false;orderId = ''"
    />
  </div>
</template>
<script>
import { Goods_Acount_Detail } from "@/api/work/acount/salesAcount";
import { timestampToDate, timestampToTime } from "@/utils/timestamp";
import orderDetail from "../../order/orderDetail";
import Calendar from "@/components/Calendar";
export default {
  name: "goodsAcountDetail",
  components: {
    orderDetail,
    Calendar,
  },
  filters: {
    toDate(t) {
      return timestampToDate(t);
    },
    toTime(t) {
      return timestampToTime(t);
    },
  },
  data() {
    return {
      unit_list: [
        { value: 1, name: "件" },
        { value: 2, name: "包" },
        { value: 3, name: "袋" },
        { value: 4, name: "盒" },
        { value: 5, name: "瓶" },
        { value: 6, name: "箱" },
        { value: 7, name: "罐" },
      ],
      list: [],
      isFinished: true,
      data_picker: [],
      goods_type: "", //判断是不是附加费
      detailQuery: {
        name: "",
        bale: "",
        goods_total_price: "",
        count: "",
        s: "",
        e: "",
        page: 1,
        pagesize: 55,
        batch:''
      },
      isPopupShow: false, //是否显示右边详情
      orderId: "",
    };
  },
  created() {
    this.detailQuery.name = this.$route.query.name || '';
    this.detailQuery.bale = this.$route.query.bale || '';
    this.goods_type = this.$route.query.goods_type;
    this.detailQuery.s = this.$route.query.s || '';
    this.detailQuery.e = this.$route.query.e||'';
    this.detailQuery.batch=this.$route.query.batch || ''
     if(this.$route.query.s){
      this.data_picker[0]=new Date(this.$route.query.s).getTime()/1000
      this.data_picker[1]=new Date(this.$route.query.e).getTime()/1000     
    }
    this.getList();
  },
  mounted() {},
  methods: {
    //返回上一级
    goBack() {
      this.$router.go(-1);
    },
    //获取列表
    getList() {
      if (this.detailQuery.page == 1) {
        this.list = [];
      }
      Goods_Acount_Detail(this.detailQuery).then((res) => {
        if (res.code == 200) {
          this.detailQuery.count = res.data.count || 0;
          this.detailQuery.goods_total_price = res.data.goods_total_price || 0;
          this.list = this.list.concat(res.data.list);
        }
        if (
          this.list.length == res.data.totalCount ||
          res.data.list.length == 0
        ) {
          this.isFinished = true;
        } else {
          this.isFinished = false;
          this.detailQuery.page++;
        }
      });
    },
    //下拉刷新
    $_onEndReached() {
      if (this.isFinished) {
        return;
      }
      // async data
      this.getList();
      this.$refs.scrollView.finishLoadMore();
    },
    //选择时间
    changeTime(e) {
      if (this.data_picker) {
        this.detailQuery.s = timestampToDate(this.data_picker[0]);
        this.detailQuery.e = timestampToDate(this.data_picker[1]);
      } else {
        this.detailQuery.s = "";
        this.detailQuery.e = "";
      }
      this.detailQuery.page = 1;
      this.list = [];
      this.getList();
    },
    //详情页
    lookDetail(order_sn) {
      if (order_sn) {
        this.orderId = order_sn;
        this.isPopupShow = true;
      } else {
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsAcountDetail {
  padding: 0.1rem;
  height: 100%;
  box-sizing: border-box;
  padding-bottom: 0;
  .content {
    padding: 0.2rem;
    height: 100%;
    background: #fff;
    border-radius: 0.1rem;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding-bottom: 0;
    .back {
      margin-bottom: 0.26rem;
      color: #31b158;
      font-weight: bold;
      font-size: 0.24rem;
      height: 0.32rem;
    }
    .tl {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 0.48rem;
      margin: 0 0.22rem;
      .left {
        width: 70%;
        display: flex;
        align-items: center;
        > span {
          font-size: 0.22rem;
          color: #404040;
          > span {
            color: #31b158;
          }
        }
        > span:nth-of-type(1) {
          max-width: 2.8rem;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        > span:nth-of-type(2) {
          display: flex;
          align-items: center;
          margin: 0 0.1rem;
          > span {
            padding: 0 0.1rem;
            height: 0.24rem;
            line-height: 0.24rem;
            border-radius: 0.12rem;
            font-size: 0.18rem;
            font-weight: normal;
          }
        }
      }
    }
    .listBox {
      margin: 0 0.22rem;
      margin-top: 0.12rem;
      height: calc(100% - 0.32rem - 0.48rem - 0.14rem - 0.2rem - 0.12rem);
      .title {
        height: 0.68rem;
        border-top: 0.01rem solid #e5e5e5;
        border-bottom: 0.01rem solid #e5e5e5;
        display: flex;
        justify-content: space-between;
        align-items: center;
        > span {
          font-size: 0.22rem;
          color: #555;
          font-weight: bold;
          text-align: center;
          text-overflow: clip;
          white-space: nowrap;
          overflow: hidden;
        }
        > span:nth-of-type(1) {
          width: 0.6rem;
        }
        > span:nth-of-type(2) {
          width: 1.4rem;
        }
        > span:nth-of-type(3) {
          width: 1.4rem;
        }
        > span:nth-of-type(4) {
          width: 2.6rem;
        }
        > span:nth-of-type(5) {
          width: 2.2rem;
        }
        > span:nth-of-type(6) {
          width: 2.6rem;
        }
        > span:nth-of-type(7) {
          width: 1.4rem;
        }
        > span:nth-of-type(8) {
          width: 1.6rem;
        }
        > span:nth-of-type(9) {
          width: 0.4rem;
        }
      }
      .detailBox {
        height: calc(100% - 0.68rem);
        font-size: 0.18rem;
        .list {
          display: flex;
          justify-content: space-between;
          align-items: center;
          height: 0.6rem;
          border-bottom: 0.01rem solid #e5e5e5;
          > span {
            text-align: center;
            color: #666666;
            // text-overflow: clip;
            // white-space: nowrap;
            // overflow: hidden;
          }
          > span:nth-of-type(1) {
            width: 0.6rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(2) {
            width: 1.4rem;
          }
          > span:nth-of-type(3) {
            width: 1.4rem;
            text-align: center;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(4) {
            width: 2.6rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(5) {
            width: 2.2rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(6) {
            width: 2.6rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(7) {
            width: 1.4rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(8) {
            width: 1.6rem;
            text-overflow: ellipsis;
            white-space: nowrap;
            overflow: hidden;
          }
          > span:nth-of-type(9) {
            width: 0.4rem;
            font-size: 0.22rem;
            font-weight: bold;
          }
        }
      }
    }
  }
}
</style>